import type { Messages } from "./messages";

export const en: Messages = {
  locale: "en-US",
  name: "English",
  page: {
    title: "Planets",
    description:
      "An interactive 3D model of the solar system with the Sun, the planets, the dwarf planets and their moons.",
  },
  fatal: {
    skeleton: "page skeleton is missing #scene, #labels or #overlay",
    webgl:
      "planets.kuffel.me needs a browser with WebGL 2. Chrome, Firefox, Safari 15+ and Edge all support it.",
    startup: "startup failed:\n{error}",
    renderLoop: "render loop failed:\n{error}",
  },
  loading: "loading textures {done}/{total}",
  update: { available: "New version available", reload: "Reload", dismiss: "Dismiss" },
  stats:
    "{fps} fps · slowest {slowest} ms · CPU {cpu} ms\n" +
    "{width}×{height} @{ratio} · {draws} draw calls\n" +
    "{textures} textures · {geometries} geometries\n" +
    "kepler misses {misses} · non-finite {nonFinite}",
  statsCopy: { copy: "Copy", copied: "Copied", failed: "Copy failed" },
  viewport: {
    lines:
      "viewport {width}×{height} · visible {visual} · screen {screenWidth}×{screenHeight}\n" +
      "safe area {top} {right} {bottom} {left} · {mode}\n" +
      "vh {vh} · lvh {lvh} · dvh {dvh} · svh {svh} · body {body} · canvas {canvas}",
    installed: "installed",
    browser: "in browser",
  },
  menu: {
    label: "Menu",
    open: "Open menu",
    close: "Close menu",
    closePanel: "Close",
    tabs: { controls: "Controls", bodies: "Bodies", help: "Help" },
  },
  player: { play: "Play", pause: "Pause" },
  controls: {
    time: "Time",
    now: "Now",
    speed: "simulation speed",
    resetView: "Reset view",
    view: "View",
    trueScale: "True scale",
    labels: "Labels",
    orbits: "Orbits",
    fullscreen: "Fullscreen",
    language: "Language",
  },
  speed: {
    realTime: "real time",
    units: {
      year: { one: "{count} year", other: "{count} years" },
      month: { one: "{count} month", other: "{count} months" },
      day: { one: "{count} day", other: "{count} days" },
      hour: { one: "{count} hour", other: "{count} hours" },
      minute: { one: "{count} minute", other: "{count} minutes" },
      second: { one: "{count} second", other: "{count} seconds" },
    },
    short: { year: "yr", month: "mo", day: "d", hour: "h", minute: "min", second: "s" },
  },
  kinds: { star: "star", planet: "planet", dwarf: "dwarf planet", moon: "moon" },
  subtitle: { ofSun: "{kind} of the Sun", of: "{kind} of {parent}" },
  info: {
    radius: "Radius",
    equatorialRadius: "Equatorial radius",
    equator: "Equator",
    unknown: "unknown",
    day: "Day",
    axialTilt: "Axial tilt",
    moons: "Moons",
    showMoons: "Show moons in Bodies ›",
    hours: "{count} h",
    days: { one: "{count} day", other: "{count} days" },
    years: { one: "{count} year", other: "{count} years" },
    retrograde: "{period}, retrograde",
    year: "Year",
    period: "Period",
    tabs: { overview: "Overview", body: "Body", orbit: "Orbit" },
    tabsLabel: "Details",
    mass: "Mass",
    gravity: "Gravity",
    density: "Density",
    temperature: "Temperature",
    distance: "Distance",
    eccentricity: "Eccentricity",
    inclination: "Inclination",
    inclinationEquator: "Inclination (to equator)",
    inclinationLaplace: "Inclination (to Laplace plane)",
    speed: "Speed",
    about: "about {value}",
    galacticOrbit: "around the galaxy centre",
    auDistance: "{au} AU ({millionKm} million km)",
    lightYears: { one: "{count} light-year", other: "{count} light-years" },
    millionYears: { other: "{count} million years" },
  },
  bodies: {
    search: "Search {count} bodies…",
    searchLabel: "Search bodies",
    moons: { one: "{count} moon", other: "{count} moons" },
    showMoons: "Show moons of {name}",
    hideMoons: "Hide moons of {name}",
    more: "+{count} more, type to search",
    noMatch: 'No body named "{query}"',
    focus: "Focus on {name}",
  },
  help: {
    keyboard: "Keyboard",
    advanced: "Advanced",
    stats: "Performance stats",
    about: "About",
    credits:
      "Orbital data: NASA/JPL Solar System Dynamics. Textures: {scope} ({license}; dwarf-planet maps are fictional).",
    keyNames: { Space: "Space" },
    keys: {
      pause: "Play / pause",
      faster: "Faster",
      slower: "Slower",
      scale: "True scale",
      labels: "Labels",
      orbits: "Orbits",
      home: "Back to the Sun",
      escape: "Close menu or info card, else back to the Sun",
      menu: "Menu",
      search: "Search bodies",
      help: "Shortcuts",
      stats: "Performance stats",
    },
  },
  bodyNames: {},
};
